import React, {useState, useEffect} from 'react'
import styles from './index.module.scss'
import Clock from '../../components/Clock/Clock'
import Navbar from '../../components/Navbar'
import Tables from '../../components/Tables'
import Decr from '../../components/Decr'
import Popup from '../../components/Popup'
import BusinessLunch from '../../components/BusinessLunch'
import moment from 'moment'
import FullMenu from '../../components/FullMenu'
import { MdEdit } from 'react-icons/md'
import Name from '../../components/Name'
import Timer from '../../components/Timer'
import { FiArrowRightCircle } from 'react-icons/fi'
import { createPaymentOrderFromPos, cancelOrder } from '../../api/orders'
import PaymentChoice from '../../components/PaymentChoice'
import ReceiptContact from '../../components/ReceiptContact'

const Index = ({ isQrMode = false }) => {
  const BL_PRICE = 450;
  const [isActive, 
        setIsActive] = useState(true);
  const [isActive_, 
        setIsActive_] = useState(false);
    const [blList,
        setBlList] = useState([])
    const [fullMenuList,
        setFullMenuList] = useState([])
    const [openMenu,
        setOpenMenu] = useState(false)
    const [request,
        setRequest] = useState([])
    const [token,
        setToken] = useState(null)
    const [tables,
        setTables] = useState(null)
    const [orderId,
        setOrderId] = useState(null)
    const [paymentData,
        setPaymentData] = useState(null) // {qrUrl, paymentOrderId, status}
    const [paymentMode,
        setPaymentMode] = useState(null) // 'qr' | 'waiter' | null
    const [showReceiptContact,
        setShowReceiptContact] = useState(false)
    const [isOpenDecr,
        setIsOpenDecr] = useState(null)
    const [isOpenName,
        setIsOpenName] = useState(false)
    const [selectedDate,
        setSelectedDate] = useState(moment().format('YYYY-MM-DD'))
    const [steps,
        setSteps] = useState({
            isActive: 1,
            guestСount: 1,
            table: null
        })
    const [guests,
        setGuests] = useState('')

    const blItems = request.filter(item => item?.category !== undefined && item?.category !== null)
    const mainMenuItems = request.filter(item => item?.category === undefined || item?.category === null)


    const getMenuList = (date) => { // получаем меню бизнес-ланча
        const dateStr = date || moment().format('YYYY-MM-DD')
        try {
            const response = fetch(`https://api-dev.menu-rest.com/api/v1/restaurant/16271/businessmenu/${dateStr}`)
                .then(response => response.json())
                .then(data => {
                    setBlList(data.data)
                })
        } catch (error) {
            return error
        }
    }

    const getTables = () => { // получаем список столов
        try {
            const response = fetch(`https://api-dev.menu-rest.com/api/v1/table/16271`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(data => {
                setTables(data.data)
            })
        } catch (error) {
            return error
        }
    }

    const getMainMenuList = () => { // получаем полное меню
        try {
            const response = fetch(`https://api-dev.menu-rest.com/api/v1/restaurant/16271/menu`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(data => {
                setFullMenuList(data.data)
            })
        } catch (error) {
            return error
        }
    }

    async function fetchAuthToken() { // получаем токен
        const url = 'https://api-dev.menu-rest.com/api/v1/auth/phonegetpin';
        const body = JSON.stringify({
            phone: '+78999999999'
        });
    
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body
            });
    
            if (!response.ok) {
                throw new Error('Failed to fetch token');
            }
    
            const data = await response.json();
            fetchAuthToken_();
            return data.token;
        } catch (error) {
            throw error;
        }
    }

    async function fetchAuthToken_() {
        const url = 'https://api-dev.menu-rest.com/api/v1/auth/phonelogin';
        const body = JSON.stringify({
            phone: '+78999999999',
            pin: '12345'
        });
    
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body
            });
    
            if (!response.ok) {
                throw new Error('Failed to fetch token');
            }
    
            const data = await response.json();
            setToken(data.token);
        } catch (error) {
            throw error;
        }
    }

    const handleGetAddDecription = (item) => {
        setIsOpenDecr(item.id)
    }

    const handleCancel = async () => { // отменяем заказ
        try {
            // Отменяем заказ в ресторанной системе (только если заказ был создан)
            if (orderId) {
                await fetch(`https://api-dev.menu-rest.com/api/v1/order/16271/order/${orderId}/close`, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
            }

            // Отменяем заказ на оплату через СБП (если есть)
            if (paymentData?.paymentOrderId) {
                try {
                    await cancelOrder(paymentData.paymentOrderId);
                } catch (e) {
                    console.error('Ошибка отмены оплаты:', e);
                }
            }

            setIsActive_(true);
            setPaymentData(null);
        } catch (error) {
            console.error(error);
            return error
        }
    }

    useEffect(() => {
        if (!token) {
            fetchAuthToken();
        }
    }, [token])

    useEffect(() => {
        getMenuList(selectedDate);
    }, [selectedDate])

    useEffect(() => {
        if (token != null) {
            getMainMenuList();
            getTables();
        }
    }, [token])

    const handleGetRequest = (item, type) => { 
        const copy = [...request]
        if (type === 'add') {
            copy.push(item)
        } else {
            const index = copy.findIndex((element) => element.id == item.id);

            if (index !== -1) {
                copy.splice(index, 1);
            }
        }
        setRequest(copy)
    }

    const getUniqueArray = (array) => { 
        return array.filter((item, index, self) => index === self.findIndex((t) => t.id === item.id))
    }

    function groupOrdersByCategory(orders) {
        // Группируем заказы по категориям
        const grouped = {1: [], 2: [], 3: [], 4: [], 5: []};
        orders?.forEach(order => {
            if (order?.category) {
                grouped[order.category]?.push(order);
            }
        });
    
        // Находим максимальное количество заказов в каждой категории
        const maxLength = Math.max(grouped[1].length, grouped[2].length, grouped[3].length, grouped[4].length, grouped[5].length);
        
        // Массив для хранения результатов
        const result = [];
    
        // Собираем результат по "пакетам" заказов из разных категорий
        for (let i = 0; i < maxLength; i++) {
            const batch = [];
            
            for (let category = 1; category <= 5; category++) {
                if (grouped[category][i]) {
                    batch.push(grouped[category][i]);
                }
            }
            
            if (batch.length > 0) {
                result.push(batch);
            }
        }
    
        return result;
    }

    const getMainMenuItemsWithAmount = () => {
        const aggregated = {};
        mainMenuItems.forEach(item => {
            if (!aggregated[item.id]) {
                aggregated[item.id] = {...item, amount: 0};
            }
            aggregated[item.id].amount += 1;
        });
        return Object.values(aggregated);
    }

    const getBlSets = () => groupOrdersByCategory(blItems);

    const getTotalPrice = () => {
        const blTotal = getBlSets().length * BL_PRICE;
        const mainTotal = mainMenuItems.reduce((sum, item) => {
            const price = parseFloat(item?.price || 0);
            return sum + (isNaN(price) ? 0 : price);
        }, 0);
        return blTotal + mainTotal;
    }

    const handleSubmitRequest = (type) => {
        if (type === 'cancel') {
            handleCancel();
        }
        setRequest([])
        setPaymentData(null)
        setPaymentMode(null)
        setShowReceiptContact(false)
        setSteps({
            isActive: 1,
            guestСount: 1,
            table: null
        })
    }


    const getGuestsErr = (guestСount) => {
        const guests_list = []
        for (let i = 0; i < guestСount; i++) {
            guests_list.push(guests)
        }
        return guests_list
    }

    const createOrder = async () => {
        try {
            const response = await fetch(`https://api-dev.menu-rest.com/api/v1/order/16271/table/${steps.table}/create`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({guests: getGuestsErr(steps.guestСount)})
            })
            const data = await response.json();
            const newOrderId = data.data?.[0]?.id;
            if (!newOrderId) {
                throw new Error('Не удалось создать заказ');
            }
            setOrderId(newOrderId);

            const blSets = getBlSets();
            for (const set of blSets) {
                await handleAddBLFood(newOrderId, set);
            }

            const mainItemsWithAmount = getMainMenuItemsWithAmount();
            for (const item of mainItemsWithAmount) {
                await handleAddMainMenuFood(newOrderId, item);
            }

            return newOrderId;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    const createAndSendOrder = async () => {
        const newOrderId = await createOrder();
        await handleSent(newOrderId);
        return newOrderId;
    }

    const handleCreateGuests = async () => {
        setIsOpenName(false);
        setGuests('');

        if (isQrMode) {
            setSteps(prev => ({...prev, isActive: 3}));
        } else {
            setPaymentMode('waiter');
            setSteps(prev => ({...prev, isActive: 4}));
            await createAndSendOrder();
        }
    }

    const handleAddBLFood = async (orderId_, items) => {
        if (!items || items.length === 0) return;
        const payload = items.map(_el => ({
            orderid: orderId_,
            guest_id: 1,
            menu_id: _el.id,
            bl_category_id: _el.category,
            amount: 1,
            qr_payment: false,
            orderrowcomment: _el.decr,
            orderoptions: null
        }));
        try {
            await fetch(`https://api-dev.menu-rest.com/api/v1/order/16271/order/${orderId_}/${blList?.[0]?.bid}/1`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            })
        } catch (error) {
            console.error(error);
            return error
        }
    }

    const handleAddMainMenuFood = async (orderId_, item) => {
        try {
            await fetch(`https://api-dev.menu-rest.com/api/v1/order/16271/order/${orderId_}/1`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    menu_id: item.id,
                    amount: item.amount,
                    orderrowcomment: item.decr || null,
                    orderoptions: null
                })
            })
        } catch (error) {
            console.error(error);
            return error
        }
    }

    const handleSent = async (id) => {
        try {
            await fetch(`https://api-dev.menu-rest.com/api/v1/order/16271/order/${id}/sent`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
            })

        } catch (error) {
            console.error(error);
            return error
        }
    }

    // Оплата по QR
    const handleQrPayment = async (receiptContact = {}) => {
        try {
            const newOrderId = await createOrder();

            // Обычные блюда: { menu_id, position_count }
            const paymentItems = [];
            mainMenuItems.forEach(item => {
                const existing = paymentItems.find(p => p.menu_id === item.id);
                if (existing) {
                    existing.position_count += 1;
                } else {
                    paymentItems.push({ menu_id: item.id, position_count: 1 });
                }
            });

            // Бизнес-ланчи: каждый сет — отдельный { bl_id, count: 1, choices }
            const blId = blList?.[0]?.bid;
            const businessLunches = getBlSets().map(set => ({
                bl_id: blId,
                count: 1,
                choices: set.map(item => ({ category: item.category, menu_id: item.id }))
            }));

            const paymentResponse = await createPaymentOrderFromPos({
                posOrderId: newOrderId,
                description: `Заказ №${newOrderId}`,
                items: paymentItems,
                businessLunches,
                ...receiptContact
            });

            setPaymentData({
                qrUrl: paymentResponse.qr_url,
                paymentOrderId: paymentResponse.order_id,
                status: paymentResponse.status
            });

            setPaymentMode('qr');
            setSteps(prev => ({...prev, isActive: 4}));
        } catch (error) {
            console.error(error);
        }
    }

    const handleWaiterPayment = async () => {
        await createAndSendOrder();
        setPaymentMode('waiter');
        setPaymentData(null);
        setSteps(prev => ({...prev, isActive: 4}));
    }

    // Вернуться к выбору способа оплаты
    const handleBackToPaymentChoice = async () => {
        if (paymentMode === 'qr' && paymentData?.paymentOrderId) {
            try {
                await cancelOrder(paymentData.paymentOrderId);
            } catch (e) {
                console.error('Ошибка отмены оплаты:', e);
            }
        }

        if (orderId) {
            try {
                await fetch(`https://api-dev.menu-rest.com/api/v1/order/16271/order/${orderId}/close`, {
                    method: 'PUT',
                    headers: { 'Authorization': `Bearer ${token}` }
                });
            } catch (e) {
                console.error(e);
            }
            setOrderId(null);
        }

        setPaymentData(null);
        setPaymentMode(null);
        setSteps(prev => ({...prev, isActive: 3}));
    }

    const handleAddName = (id) => {
        try {
            const response = fetch(`https://api-dev.menu-rest.com/api/v1/order/16271/orderguest/${id}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({name: guests})
            })
            .then(response => response.json())
            .then(data => {
                setSteps({...steps, isActive: steps.isActive + 1});
                setIsOpenName(false);
                setGuests('');
            })
        } catch (error) {
            return error
        }
    }

    const handleOpenMenu = () => {
        setOpenMenu(true);
    }
    
    return (
        <div className={styles.wrapper} id='no'>
            <Timer
                isActive={isActive}
                setIsActive={setIsActive}
                isActive_={isActive_}
                setIsActive_={setIsActive_}
                handleSubmitRequest={handleSubmitRequest}
                setIsOpenName={setIsOpenName}
                setGuests={setGuests}
                disabled={steps.isActive >= 3} />
            <Clock selectedDate={selectedDate} setSelectedDate={setSelectedDate} />

            <div className={styles.content}>
                    {
                        (steps.isActive > 1) ? <></> : (
                            !openMenu ? <div className={styles.openMenu} onClick={() => handleOpenMenu()}>В меню&nbsp;<FiArrowRightCircle/></div> : <></>
                        )
                    }
                    
                    {request.length > 0
                        ? <div className={styles.request}>
                            <div className={styles.requestList}>
                                {getUniqueArray(request).map((item, index) => {
                                    return (
                                        <div key={index} className={styles.requestItem}>
                                            {item.title_ru} - {request.filter(item_ => item_.id === item.id).length}
                                            <MdEdit onClick={() => handleGetAddDecription(item)}/>
                                        </div>
                                    )
                                })} 
                            </div>
                        </div>
                        : <></>}
                <Navbar/>
                <div className={styles.menu}>
                    <div className={styles.menuWrapper}>
                        {steps.isActive === 3 && isQrMode && (
                            <PaymentChoice
                                onQrPayment={() => setShowReceiptContact(true)}
                                onWaiterPayment={handleWaiterPayment}
                                onCancel={() => handleSubmitRequest('cancel')}
                                totalPrice={getTotalPrice()}
                            />
                        )}

                        {showReceiptContact && (
                            <ReceiptContact
                                onConfirm={async (contact) => {
                                    setShowReceiptContact(false);
                                    await handleQrPayment(contact);
                                }}
                                onCancel={() => setShowReceiptContact(false)}
                            />
                        )}

                        {steps.isActive === 4 && (
                            <Popup
                                orderId={orderId}
                                count={getBlSets()}
                                totalPrice={getTotalPrice()}
                                steps={steps}
                                setSteps={setSteps}
                                request={request}
                                getUniqueArray={getUniqueArray}
                                handleSubmitRequest={handleSubmitRequest}
                                paymentData={paymentData}
                                setPaymentData={setPaymentData}
                                paymentMode={paymentMode}
                                onBack={handleBackToPaymentChoice}
                                isQrMode={isQrMode}
                                onPaymentSuccess={null}
                            />
                        )}

                        {isOpenDecr && 
                            <Decr 
                            setIsOpenDecr={setIsOpenDecr}
                            isOpenDecr={isOpenDecr}
                            setRequest={setRequest} 
                            request={request} 
                            handleGetRequest={handleGetRequest} 
                            handleGetAddDecription={handleGetAddDecription} /> }
                        {steps.isActive === 2 && <Tables tables={tables} setSteps={setSteps} steps={steps} request={request} /> }
                        
                        {request.length > 0 && 
                        steps.isActive === 2 &&
                        steps.table !== null &&
                        <div className={styles.requestButton} onClick={() => setIsOpenName(true)}>заказать</div>}

                        {steps.isActive === 1 && (
                            <>
                            {
                                !openMenu ? 
                                <BusinessLunch
                                    isActive={steps.isActive}
                                    data={blList}
                                    steps={steps}
                                    setSteps={setSteps}
                                    request={request}
                                    handleGetRequest={handleGetRequest} />
                                : 
                                <FullMenu 
                                    isActive={steps.isActive}
                                    fullMenu={fullMenuList} 
                                    closeMenu={() => setOpenMenu(false)}
                                    request={request}
                                    handleGetRequest={handleGetRequest}
                                    steps={steps}
                                    setSteps={setSteps}
                                />
                            }
                            </>
                            )
                        }

                        

                        {
                            isOpenName &&
                            <Name 
                            guests={guests}
                            setGuests={setGuests}
                            handleCreateGuests={handleCreateGuests}
                            />
                        }
                    
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Index